import { __makeTemplateObject } from "tslib";
import { Typography, createStyles, makeStyles } from "@material-ui/core";
import { alpha } from "@material-ui/core/styles";
import styled from "styled-components";
export var useStyles = makeStyles(function (theme) {
    return createStyles({
        iconClass: {
            cursor: "pointer"
        },
        textCenter: {
            textAlign: "center"
        },
        noHeaderMargin: {
            marginBottom: "0 !important"
        },
        noPadding: {
            padding: "0 !important"
        },
        expandRowGap: {
            gap: 25
        },
        iconsGap: {
            gap: 9
        },
        tableBgColor: {
            backgroundColor: theme.palette.colors.basic[900]
        },
        rowPadding: {
            paddingLeft: 0,
            paddingBottom: 0,
            paddingTop: 0
        },
        cancelBtn: {
            borderRadius: "4px !important",
            borderColor: "hsl(224,5%,60%) !important",
            backgroundColor: "transparent !important",
            color: "hsla(0,0%,100%,0.6) !important",
            borderWidth: "1px !important",
            borderStyle: "solid !important",
            marginRight: "15px !important"
        }
    });
});
export var FieldLabel = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tfont-family: var(--openSans);\n\tfont-size: 13px;\n\tfont-weight: 600;\n\tline-height: 1.85;\n\tcolor: ", ";\n\n\tmargin: 0 0 24px 0;\n"], ["\n\tfont-family: var(--openSans);\n\tfont-size: 13px;\n\tfont-weight: 600;\n\tline-height: 1.85;\n\tcolor: ", ";\n\n\tmargin: 0 0 24px 0;\n"])), function (_a) {
    var theme = _a.theme;
    return alpha(theme.palette.text.primary, 0.6);
});
export var AddUpdateText = styled(Typography)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin-top: 0;\n\tmargin-left: ", ";\n\tcolor: ", ";\n"], ["\n\tmargin-top: 0;\n\tmargin-left: ", ";\n\tcolor: ", ";\n"])), function (_a) {
    var $isLoading = _a.$isLoading;
    return ($isLoading ? "0.5rem" : "0");
}, function (_a) {
    var theme = _a.theme, $disabled = _a.$disabled;
    return ($disabled ? theme.palette.text.disabled : theme.palette.common.white);
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map